import React, { useState, useEffect } from 'react';
import PurchaseTable, { PurchaseRow, Distributor } from './Purchase-table';

interface AddingMedicationProps {
  onCsvUpload?: (csvData: any[], sourceType?: 'csv' | 'pdf') => void;
  onRegisterCsvMapping?: (applyFn: (csvData: any[], mapping: { [key: string]: string | string[] }) => void) => void;
  onUploadStart?: () => void;
  onUploadEnd?: () => void;
  onUploadUsed?: () => void;
  onSubmitSuccess?: (message: string) => void;
  onSubmitError?: (message: string) => void;
  onAddDistributor?: () => void;
  onRegisterDistributorRefresh?: (refreshFn: () => void) => void;
  onEditDistributor?: (distributor: any) => void;
  onRegisterFormReset?: (resetFn: () => void) => void;
  onImageClick?: (imageUrl: string, medicineName: string) => void;
  onRegisterGetData?: (getDataFn: () => any) => void;
  initialPurchaseData?: { rows: PurchaseRow[]; selectedDistributor: Distributor | null };
}

const AddingMedication: React.FC<AddingMedicationProps> = ({ onCsvUpload, onRegisterCsvMapping, onUploadStart, onUploadEnd, onUploadUsed, onSubmitSuccess, onSubmitError, onAddDistributor, onRegisterDistributorRefresh, onEditDistributor, onRegisterFormReset, onImageClick, onRegisterGetData, initialPurchaseData }) => {
  const [isMobile, setIsMobile] = useState(window.innerWidth < 768);

  // Handle window resize for mobile detection
  useEffect(() => {
    const handleResize = () => {
      setIsMobile(window.innerWidth < 768);
    };
    window.addEventListener('resize', handleResize);
    return () => window.removeEventListener('resize', handleResize);
  }, []);

  return (
    <div style={{
      width: '100%',
      background: 'white',
      borderRadius: '0',
      paddingTop: isMobile ? '1rem' : '2rem',
      paddingRight: isMobile ? '0.5rem' : '0',
      paddingBottom: isMobile ? '1rem' : '2rem',
      paddingLeft: isMobile ? '0.5rem' : '0',
      boxShadow: isMobile ? '0 2px 4px rgba(0, 0, 0, 0.08)' : '0 4px 6px rgba(0, 0, 0, 0.1)',
      border: '1px solid rgba(16, 185, 129, 0.1)',
      marginTop: '0',
      marginBottom: '0',
      marginLeft: '0',
      marginRight: '0',
      boxSizing: 'border-box',
      overflowX: 'hidden',
      display: 'flex',
      flexDirection: 'column',
      alignItems: isMobile ? 'center' : 'stretch',
      justifyContent: 'center'
    }}>
      <PurchaseTable 
        onCsvUpload={onCsvUpload}
        onRegisterCsvMapping={onRegisterCsvMapping}
        onUploadStart={onUploadStart}
        onUploadEnd={onUploadEnd}
        onUploadUsed={onUploadUsed}
        onSubmitSuccess={onSubmitSuccess}
        onSubmitError={onSubmitError}
        onAddDistributor={onAddDistributor}
        onRegisterDistributorRefresh={onRegisterDistributorRefresh}
        onEditDistributor={onEditDistributor}
        onRegisterFormReset={onRegisterFormReset}
        onImageClick={onImageClick}
        onRegisterGetData={onRegisterGetData}
        initialData={initialPurchaseData}
      />
    </div>
  );
};

export default AddingMedication;

